import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Loader2, ArrowUpRight } from 'lucide-react';
import { api } from '../lib/api';
import { ProductCard } from './Catalog';
import { toast } from 'sonner';

const NewArrivals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/products')
      .then((r) => {
        const list = [...r.data].sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
        setProducts(list.slice(0, 8));
      })
      .catch(() => toast.error('Impossible de charger les nouveautés'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="catalogue" data-testid="new-arrivals-section" className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="mb-4 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.35em] text-neon"
      >
        <span className="inline-block h-px w-10 bg-neon/60" /> Arrivées récentes / labo
      </motion.p>
      <div className="flex flex-wrap items-end justify-between gap-6">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl lg:text-4xl"
        >
          Les 8 dernières <span className="text-neon text-glow">références.</span>
        </motion.h2>
        <Link
          to="/boutique"
          data-testid="new-arrivals-see-all-top"
          className="clip-frame-sm flex items-center gap-2 border border-neon/40 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neon transition-all hover:bg-neon hover:text-void"
        >
          Voir tout le catalogue <ArrowUpRight size={13} />
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-24" data-testid="new-arrivals-loading">
          <Loader2 className="animate-spin text-neon" size={32} />
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-10 lg:grid-cols-4" data-testid="new-arrivals-grid">
          {products.map((p, i) => (
            <ProductCard key={p.id} p={p} index={i} />
          ))}
        </div>
      )}

      <div className="mt-14 flex justify-center">
        <Link
          to="/boutique"
          data-testid="new-arrivals-see-all"
          className="clip-frame-sm inline-flex items-center gap-2 bg-neon px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-void transition-colors hover:bg-cyber"
        >
          Explorer tout le catalogue <ArrowUpRight size={14} />
        </Link>
      </div>
    </section>
  );
};

export default NewArrivals;
